import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query ucceAgents($startIndex: Int, $pageSize: Int, $search: String) {
  ucceAgents(startIndex: $startIndex, pageSize: $pageSize, search: $search) {
    agents {
      agentId
      firstName
      lastName
      userName
    }
    pageSize
    startIndex
    totalCount
  }
}
`;

function getUcceAgents({ startIndex, pageSize, search }) {
  return apollo.client.query({
    query,
    variables: {
      startIndex,
      pageSize,
      search,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.ucceAgents);
}

export default getUcceAgents;
